import { BACKEND_ROUTES } from "../../backendRoutes";
import { FRONTEND_ROUTES } from "../../frontendRoutes";
import { MODEL_PROPTYPES } from "../../models";
import PropTypes from "prop-types";

export const roleWithPermissions = PropTypes.shape({
    ...MODEL_PROPTYPES.Role,
    Permissions: PropTypes.arrayOf(PropTypes.shape(MODEL_PROPTYPES.Permission)),
});

const ROLE_CHIP_COLORS = ["primary", "success", "warning", "info", "secondary"];

export function getRoleColor(roleName) {
    let hash = 0;
    for (let i = 0; i < roleName.length; i++) {
        hash = roleName.charCodeAt(i) + ((hash << 5) - hash);
    }
    return ROLE_CHIP_COLORS[Math.abs(hash) % ROLE_CHIP_COLORS.length];
}

export function formatPermissions(permissions) {
    return (permissions ?? [])
        .map((p) => `${p.action}:${p.subject}`)
        .join(" · ");
}

/**
 * Describes the entity whose user roles are managed, from the route params.
 * `levelFilter` and `isOwnLevel` exclude child rows (e.g. contract roles on
 * a company page); a bare query key is parsed as null by the backend.
 * @param {{ companyUuid?: string, contractUuid?: string, siteUuid?: string }}
 * params - Route params; the most specific one wins.
 */
export function getUserRoleScope({ companyUuid, contractUuid, siteUuid }) {
    const ordersRoot = `/${FRONTEND_ROUTES.ORDERS}`;

    if (siteUuid)
        return {
            type: "site",
            uuid: siteUuid,
            entityUrl: `${BACKEND_ROUTES.SITE}/${siteUuid}?parentInfo=true`,
            backPath: `${ordersRoot}/${FRONTEND_ROUTES.CONTRACT}/${contractUuid}`,
            levelFilter: "",
            isOwnLevel: () => true,
            getBreadcrumbs: (site) => ({
                company: site.Contract?.Company,
                contract: site.Contract,
                site,
            }),
        };

    if (contractUuid)
        return {
            type: "contract",
            uuid: contractUuid,
            entityUrl: `${BACKEND_ROUTES.CONTRACT}/${contractUuid}?parentInfo=true`,
            backPath: `${ordersRoot}/${FRONTEND_ROUTES.CONTRACT}`,
            levelFilter: "&siteUuid",
            isOwnLevel: (userRole) => userRole.siteUuid === null,
            getBreadcrumbs: (contract) => ({
                company: contract.Company,
                contract,
            }),
        };

    return {
        type: "company",
        uuid: companyUuid,
        entityUrl: `${BACKEND_ROUTES.COMPANY}/${companyUuid}`,
        backPath: `${ordersRoot}/${FRONTEND_ROUTES.COMPANY}`,
        levelFilter: "&contractUuid",
        isOwnLevel: (userRole) => userRole.contractUuid === null,
        getBreadcrumbs: (company) => ({ company }),
    };
}
